import * as transitions from './transitions.css';

export const fromBottom = {
  enter: transitions['from-bottom-enter'],
  enterActive: transitions['from-bottom-enter-active'],
  exit: transitions['from-bottom-exit'],
  exitActive: transitions['from-bottom-exit-active'],
};
export const fromTop = {
  enter: transitions['from-top-enter'],
  enterActive: transitions['from-top-enter-active'],
  exit: transitions['from-top-exit'],
  exitActive: transitions['from-top-exit-active'],
};
